module.exports = __webpack_public_path__ + "img/bitcoin.e2d0166d.jpg";